export enum OutlookSyncEntityType {
  AbEntry = 1,
  Lead = 2,
}

export enum OutlookSyncType {
  Contacts = 1,
  Appointments = 2,
  Tasks = 3,
  Emails = 4,
}
